import Vue from 'vue';
import api from '../bu/api';
import LocaleCurrency from 'locale-currency';
import Cookies from 'js-cookie';
import { getCurrencySymbol } from '../currency';

export default {
	namespaced: true,

	state: () => ({
		currency: null,
		currencies: [],
		currencyRateMap: {
			base: null,
			rates: {},
		},
	}),

	getters: {
		currency(state) {
			let currency = Cookies.get('currency');
			if (!currency) {
				const language = navigator.language;
				currency = LocaleCurrency.getCurrency(language);
			}
			if (!['TWD', 'EUR', 'USD'].includes(currency)) {
				currency = 'TWD';
			}
			return state.currency || currency || 'TWD';
		},
		currencies(state) {
			return state.currencies;
		},
		currencyOptions(state) {
			const options = state.currencies.map(currency => ({
				...currency,
				label: currency.alphabetCode + ' ' + getCurrencySymbol(currency.alphabetCode),
				value: currency.alphabetCode,
			}));
			options.sort((a, b) => {
				if (a.value === 'TWD') {
					return -1;
				} else {
					return a.label.localeCompare(b.label);
				}
			})
			return options;
		},
		currencyRateMap(state) {
			return state.currencyRateMap;
		},
	},

	actions: {
		async getCurrencies({ commit, state }) {
			if (state.currencies.length === 0) {
				const response = await api.getCurrencies();
				const result = response.data;
				const rateMap = {
					base: result?.base,
					rates: result?.rates || {},
				};
				commit('setCurrencies', result?.currencies || []);
				commit('setCurrencyRateMap', rateMap);
			}
		},
		setCurrency({ commit }, currency) {
			Cookies.set(
                'currency',
                currency,
                { path: '/', domain: window.location.hostname }
            );
			commit('setCurrency', currency);
		},
	},

	mutations: {
		setCurrency(state, currency) {
			Vue.set(state, 'currency', currency);
		},
		setCurrencies(state, currencies) {
			Vue.set(state, 'currencies', currencies);
		},
		setCurrencyRateMap(state, rateMap) {
			Vue.set(state, 'currencyRateMap', rateMap);
		},
	}
}
